import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_labpronics-tech/artifacts/a7d11asc_ChatGPT%20Image%20Aug%204%2C%202026%2C%2003_51_10%20AM.png";

const LINKS = [
  ["Home", "/"],
  ["About", "/about"],
  ["Solutions", "/solutions"],
  ["Services", "/services"],
  ["Industries", "/industries"],
  ["Projects", "/projects"],
  ["OEM Partners", "/oem-partners"],
  ["Certifications", "/certifications"],
  ["Insights", "/insights"],
  ["Contact", "/contact"],
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const solid = scrolled || location.pathname !== "/";

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid ? "bg-white/95 backdrop-blur border-b border-lp-border shadow-[0_1px_20px_rgba(10,43,110,0.06)]" : "bg-transparent"
      }`}
    >
      <nav className="container-lp flex items-center justify-between h-[74px]">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="nav-logo">
          <img src={LOGO} alt="Labpronics" className="h-11 w-11 object-contain" />
          <div className="leading-none">
            <div className="font-heading font-700 text-lp-blue text-[16px] tracking-tight">Labpronics Technologies</div>
            <div className="text-[9px] tracking-[0.18em] uppercase text-lp-muted font-600">Pvt. Ltd.</div>
          </div>
        </Link>

        <div className="hidden xl:flex items-center gap-5">
          {LINKS.map(([label, to]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={`nav-link-${label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `relative text-[13px] font-600 tracking-wide transition-colors ${isActive ? "text-lp-cyan" : "text-lp-ink hover:text-lp-blue"}`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link to="/contact" data-testid="nav-cta-contact" className="hidden sm:inline-flex items-center gap-2 bg-lp-blue text-white text-[13px] font-600 px-5 py-2.5 rounded-sm hover:bg-lp-steel transition-colors group">
            Get in Touch <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <button className="xl:hidden text-lp-blue" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="xl:hidden bg-white border-t border-lp-border max-h-[80vh] overflow-y-auto" data-testid="nav-mobile-menu">
          <div className="container-lp py-4 flex flex-col gap-1">
            {LINKS.map(([label, to]) => (
              <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `py-2.5 text-[15px] font-600 border-b border-lp-border/60 ${isActive ? "text-lp-cyan" : "text-lp-ink"}`}>
                {label}
              </NavLink>
            ))}
            <Link to="/contact" className="mt-3 bg-lp-blue text-white font-600 py-3 rounded-sm text-center">Get in Touch</Link>
          </div>
        </div>
      )}
    </header>
  );
}
